/**
 * @generated SignedSource<<3e51b21d17632695b8427980e16a27af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type importCatalogPaginationFragment__providerProducts$data = {
  readonly providerProducts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly imageUrl: string | null;
        readonly name: string;
      };
    }> | null;
  } | null;
  readonly " $fragmentType": "importCatalogPaginationFragment__providerProducts";
};
export type importCatalogPaginationFragment__providerProducts$key = {
  readonly " $data"?: importCatalogPaginationFragment__providerProducts$data;
  readonly " $fragmentSpreads": FragmentRefs<"importCatalogPaginationFragment__providerProducts">;
};

import importCatalogPaginationFragmentQuery_graphql from './importCatalogPaginationFragmentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "providerProducts"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "category"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": "1",
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "macroCategory"
    },
    {
      "defaultValue": "PRINTFUL",
      "kind": "LocalArgument",
      "name": "provider"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "search"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": importCatalogPaginationFragmentQuery_graphql
    }
  },
  "name": "importCatalogPaginationFragment__providerProducts",
  "selections": [
    {
      "alias": "providerProducts",
      "args": [
        {
          "kind": "Variable",
          "name": "category",
          "variableName": "category"
        },
        {
          "kind": "Variable",
          "name": "macroCategory",
          "variableName": "macroCategory"
        },
        {
          "kind": "Variable",
          "name": "provider",
          "variableName": "provider"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "ProviderProductsConnection",
      "kind": "LinkedField",
      "name": "__importCatalogPaginationFragment_providerProducts_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProviderProductsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductProviderListItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "imageUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "9808d745923bffab06a56cb2f449af87";

export default node;
